/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./Footer.css";
import Logo from "../../assests/logo.jpeg";
import { Link } from "react-router-dom";
import Google from "../../assests/GoogleImg.png";
import Apple from "../../assests/AppleImg.png";

function Footer2() {
  return (
    <div className="MainFooter">
      <div className="FooterContainer">
        <div className="footer-title">ISBC</div>
        <div className="logoFooter">
          <img src={Logo} alt="" />
        </div>
        <div className="usefullinks">
          <h3>Useful links</h3>
          <div className="Linksfooter">
            <Link to="/isbc">
              <li className="pb-3">ISBC</li>
            </Link>
            <Link to="/camps">
              <li className="pb-3">Camps </li>
            </Link>
            <Link to="/about-us">
              <li className="pb-3">About Us</li>
            </Link>
            <Link to="/terms&conditions">
              <li className="pb-3">Terms and Conditions</li>
            </Link>
            <Link to="/privacy-policy">
              <li className="pb-3">Privacy Policy</li>
            </Link>
            <Link to="/pricing-and-refund-policy">
              <li className="pb-3">Pricing and Refund Policy</li>
            </Link>
          </div>
        </div>
        <div className="address">
          <h3>Working Address</h3>
          <p>
            Address: 3-6-475/Kalpavruksha, Himayatnagar,Hyderabad,
            <br /> Telangana, India -500029
            <br />
            Phone: +91 9676594595
            <br />
            Phone: +91 9000199377
            <br />
            Email: isbccricket@gmail.com
          </p>
        </div>
        <div className="address address-registered">
          <h3>Registered Address</h3>
          <p>
            SHOP NO.1, 2ND FLOOR,
            <br />
            UNIQUEMETROPOLISNR PRASANG PARTY
            <br />
            PLOT GOTA ROAD,
            <br />
            GOTA DASKAROI
            <br />
            AHMEDABAD GUJARAT 382481
            <br />
            Email: isbccamps@gmail.com
          </p>
        </div>
        <div className="social-links">
          <h3 className="pb-3"> Connect with us </h3>
          <div className="rounded-social-buttons">
            <a
              className="social-button facebook"
              href="https://www.facebook.com/people/ISBC-Indian-Schools-Board-for-Cricket/100092425016922/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              className="social-button twitter"
              href="https://twitter.com/ISBCCricket"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              className="social-button linkedin"
              href=""
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a
              className="social-button youtube"
              href="https://www.youtube.com/@ISBCIndianSchoolsBoardforCrick"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              className="social-button instagram"
              href="https://www.instagram.com/isbcschoolsworldcup"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-instagram instaIcon"></i>
            </a>
          </div>
          <div className="download-links-ft">
            <h3 className="pb-3"> Download ISBC App </h3>
            <div className="Down-app-links-footer">
              <a href="https://apps.apple.com/us/app/isbc/id6448773651" target="_blank" rel="noreferrer">
                <img src={Apple} alt="isbc app download apple store" />
              </a>
              <a
                href=" https://play.google.com/store/apps/details?id=com.isbc.cricket&hl=en-IN"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Google} alt="isbc app download play store" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="Copyrights">
        <p> Copyright © 2023 ISBC. All rights reserved.</p>
      </div>
    </div>
  );
}

export default Footer2;
